import { render, staticRenderFns } from "./DepartmentSettingsModal.vue?vue&type=template&id=1970ab7c&scoped=true&"
import script from "./DepartmentSettingsModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSettingsModal.vue?vue&type=style&index=0&id=1970ab7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970ab7c",
  null
  
)

export default component.exports